
import { TabsContent } from "@/components/ui/tabs";
import { ExerciseListSection } from "./exercise/ExerciseListSection";
import { ExerciseFormSection } from "./exercise/ExerciseFormSection";

interface RoutineTabContentProps {
  routine: any;
  index: number;
  showExerciseForm: boolean;
  onRoutinesChange: () => void;
  onRemoveRoutine?: (routineId: string) => Promise<void>;
  handleUnlinkRoutine: (routineId: string) => Promise<void>;
  isPersonalPlan: boolean;
  canEdit: boolean;
}

export const RoutineTabContent = ({
  routine,
  index,
  showExerciseForm,
  onRoutinesChange,
  onRemoveRoutine,
  handleUnlinkRoutine,
  isPersonalPlan,
  canEdit
}: RoutineTabContentProps) => {
  // Handle exercise addition with optimized minimal update
  const handleExerciseAdded = () => {
    console.log("🎯 Exercise added - triggering optimized minimal update to preserve navigation");
    
    // Use minimal update for exercise additions to preserve tab state
    // This prevents the tab from resetting to index 0
    onRoutinesChange();
  };

  console.log("🔍 DEBUG RoutineTabContent - Optimized Props:", {
    routineId: routine.id,
    routineName: routine.name,
    exerciseCount: routine.exercises?.length || 0,
    isPersonalPlan,
    canEdit,
    showControls: canEdit,
    showExerciseForm,
    preserveNavigation: true
  });

  return (
    <TabsContent value={index.toString()} className="mt-4">
      <div className="space-y-4">
        {/* Exercise Form Section - Optimized for navigation preservation */}
        <ExerciseFormSection
          showExerciseForm={showExerciseForm}
          routineId={routine.id}
          onExerciseAdded={handleExerciseAdded}
        />

        <ExerciseListSection
          exercises={routine.exercises || []}
          routineId={routine.id}
          onExerciseChange={onRoutinesChange}
          showControls={canEdit}
          isPersonalPlan={isPersonalPlan}
        />
      </div>
    </TabsContent>
  );
};
